<div *ngIf="!showReset" class="flex justify-center items-center w-full h-full font-poppins">
    <div class="flex justify-center items-center w-full h-full">
        <svg xmlns="http://www.w3.org/2000/svg" width="321" height="317" viewBox="0 0 321 317" fill="none"
            class="opacity-80 z-10">
            <path d="M320 1H1V316H5.20844H187.855L320 171.816V1Z" fill="url(#paint0_linear_1_13)" fill-opacity="1"
                stroke="white" />
            <defs>
                <linearGradient id="paint0_linear_1_13" x1="160.5" y1="64.7975" x2="160.5" y2="316"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D2555" />
                    <stop offset="1" stop-color="#05050C" />
                </linearGradient>
            </defs>
        </svg>
        <div class="absolute top-[25%] z-20 flex justify-center items-center w-full">
            <form class="flex flex-col justify-center items-center" (ngSubmit)="verifyOtp()">
                <span
                    class="relative w-44 text-white text-center cursor-pointer before:content-[''] before:absolute before:left-0 before:bottom-0 before:w-0 before:h-[2px] before:bg-blue-500 hover:before:w-full before:transition-all before:duration-300">
                    Enter OTP
                </span>
                <div class="text-center justify-start">
                    <ng-otp-input [config]="config" (onInputChange)="onInputChange($event)">
                    </ng-otp-input>
                    <button type="submit"
                        class="relative mt-2 h-[50px] w-[250px] bg-[#31A1F6] text-white transform -translate-x-[60px] translate-y-[90px] hover:text-[#31A1F6] overflow-hidden group">
                        <span class="relative z-10">Submit</span>
                        <span
                            class="absolute inset-0 w-0 h-full bg-white transition-all duration-300 ease-in-out group-hover:w-full"></span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="showReset" class="reset-password-container animate-slideIn">
    <app-reset-password [email]="this.email"></app-reset-password>
</div>
